/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

// Enum listing all the possible ways the list items (e.g. terminals, space vehicles, networks, etc) will be grouped together
export enum PlatformListGroup {
  // Fleet View
  TERMINAL = 'TERMINAL', // Fleet view - lists all terminals; Single group for entire list

  // Transport Monitoring View
  CONNECTED = 'CONNECTED', // Lists all 'Connected' space vehicles; Paired with Disconnected group
  DISCONNECTED = 'DISCONNECTED', // Lists all 'Disconnected' space vehicles; Paired with Conencted group
  NETWORK = 'NETWORK', // Lists all networks; Single group for entire list
}

// Similar to TerminalListItem but for groups; Resembles a group header within the platform list
export type GroupListItem = {
  group: PlatformListGroup;
};

/**
 * Describes how the Platform List Groups are paired together into a set of group(s).
 * Use of generics allows us to reuse these types for different use cases.
 */
// All terminals in the Fleet list belong in one TERMINAL group
export type TerminalGroup<T> = {
  [PlatformListGroup.TERMINAL]: T;
};
// All space vehicles in Transport Monitoring list belong in either the CONNECTED or DISCONNECTED groups
export type SpaceVehicleGroups<T> = {
  [PlatformListGroup.CONNECTED]: T;
  [PlatformListGroup.DISCONNECTED]: T;
};
// All networks in Transport Monitoring list belong in one NETWORK group
export type NetworkGroup<T> = {
  [PlatformListGroup.NETWORK]: T;
};
